import React, { useState } from 'react'
import '../../../../Assets/Css/AddEmpProjectFiles.scss'
import { useNavigate, useParams } from 'react-router-dom'
import { IoClose, IoCloudUploadOutline } from 'react-icons/io5';
import { addProjectFile } from '../../../../Services/Project/action';
import { connect } from 'react-redux';
import Pdf from '../../../../Assets/Images/Employee/Pdf.svg'

const EmpProjectAddFiles = (props) => {
    const navigate = useNavigate();
    const [file_name, setFileName] = useState('');
    const [files, setFiles] = useState([]);
    const [previews, setPreviews] = useState([]);
    const { projectId } = useParams();

    const handleFileChange = (event) => {
        setFiles([]);
        setPreviews([]);
        const newFiles = Array.from(event.target.files);
        const newPreviews = newFiles.map(file => URL.createObjectURL(file));

        setFiles(prevFiles => [...prevFiles, ...newFiles]);
        setPreviews(prevPreviews => [...prevPreviews, ...newPreviews]);

    };

    const handleRemoveFile = (index) => {
        setFiles(files.filter((_, i) => i !== index));
        setPreviews(previews.filter((_, i) => i !== index));
    };

    const fileToBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
        });
    };

    const handleAddFile = async () => {
        try {
            const file = files[0];
            const base64File = await fileToBase64(file);
            const body = {
                name: file_name,
                file: base64File,
                project_id: projectId,
                type: 'files'
            }
            await props?.addProjectFile(body);
            navigate(-1);
        } catch (error) {
            console.error("Error in adding file:", error)
        }
    }

    return (
        <div className="addEmpFiles-main">
            <div className="page-title">
                <h4>Add Files</h4>
                <div className="edit-btn">
                    <button
                        type="submit"
                        className="custom-btn"
                        onClick={() => navigate(-1)}
                    >
                        Cancel
                    </button>

                    <button
                        type="submit"
                        className="custom-btn"
                        onClick={handleAddFile}
                    >
                        Save
                    </button>
                </div>
            </div>

            <div className="content-part">
                <div className="row">
                    <div className="col-md-12">
                        <div className="left-part">
                            <div className="custom-row">
                                <div className='addEmpFiles-detail'>
                                    <div className="row">
                                        <div className="input-group">
                                            <h6 className='label'>Name Of File</h6>
                                            <input type="text" className="input-css" name='filename' placeholder='Pdf File' value={file_name} onChange={(e) => setFileName(e.target.value)} />
                                        </div>
                                        <div className="input-group">
                                            <label className="label">Document</label>
                                            <div className="file-upload-wrapper">
                                                <label htmlFor="file-upload" className="file-upload-label">
                                                    <IoCloudUploadOutline />
                                                    <p>Select Files</p>
                                                    <span className='label'>Drop files here or click browse thorough your machine</span>
                                                </label>
                                                <input
                                                    type="file"
                                                    id="file-upload"
                                                    className="file-upload-input"
                                                    name="photos"
                                                    multiple
                                                    onChange={handleFileChange}
                                                />
                                            </div>
                                        </div>
                                        {previews.length > 0 && (
                                            <div className="preview">
                                                {previews.map((preview, index) => (
                                                    <div key={index} className="preview-item">
                                                        {files[index].type.startsWith('application/pdf') ? (
                                                            <div className='preview-pdf'>

                                                                <div style={{ display: 'flex', gap: '2%' }}>
                                                                    <img src={Pdf} alt="" style={{ width: "100px", height: "100px" }} />
                                                                    <div className="remove-pdf-icon" onClick={() => handleRemoveFile(index)}>
                                                                        <IoClose />
                                                                    </div>
                                                                </div>
                                                                <div className='preview-text mt-2'>
                                                                    <span className='text-center '>
                                                                        {files[index].name}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        ) : (
                                                            <div className="preview-image-wrapper">
                                                                <div style={{ display: 'flex', gap: '2%' }}>
                                                                    <img src={preview} alt={`File preview ${index}`} className="preview-image" />
                                                                    <div className="remove-icon" onClick={() => handleRemoveFile(index)}>
                                                                        <IoClose />
                                                                    </div>
                                                                </div>
                                                                <div className='preview-text mt-2'>
                                                                    <span className='text-center '>
                                                                        {files[index].name}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        )}

                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </div>


                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        loading: state.projectReducer.loading,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        addProjectFile: (data) => {
            dispatch(addProjectFile(data));
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(EmpProjectAddFiles);